import { IconNames } from '@blueprintjs/icons';
import { formatDate } from '@strata/helper-functions';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { BaseNotification } from '@strata/react-notifications';
import PropTypes from 'prop-types';

/** RES_WATCH row for treatmentClaimReversed Kafka events. */
export const TreatmentClaimReversedNotification = ({
    status,
    timestamp,
    patientName = undefined,
    productServiceOid = undefined,
    additionalData = undefined,
    onNotificationClick,
    onRemoveNotificationClick = undefined,
}) => (
    <BaseNotification
        type={BaseNotification.Types.CAUTION}
        status={status}
        icon={IconNames.UNDO}
        notificationTitle="CLAIM REVERSED"
        bodyText=" "
        timestamp={timestamp}
        onNotificationClick={onNotificationClick}
        onRemoveNotificationClick={onRemoveNotificationClick}
        additionalData={
            <div className="flex__gap--large">
                <DetailLabelValuePair label="Patient" value={patientName} />
                <DetailLabelValuePair label="Product" value={productServiceOid} />
                <DetailLabelValuePair label="Claim ID" value={additionalData?.claim_id} />
                <DetailLabelValuePair
                    label="Adjudication Date"
                    value={formatDate(additionalData?.adjudication_date)}
                />
            </div>
        }
    />
);

TreatmentClaimReversedNotification.propTypes = {
    status: PropTypes.string.isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    patientName: PropTypes.string,
    productServiceOid: PropTypes.string,
    additionalData: PropTypes.shape({
        claim_id: PropTypes.string,
        kafka_topic: PropTypes.string,
        adjudication_date: PropTypes.string,
    }),
    onNotificationClick: PropTypes.func.isRequired,
    onRemoveNotificationClick: PropTypes.func,
};
